module.exports = __webpack_public_path__ + "static/media/204-Kaffee_ID_30w.da0dc2d4.mp3";